import React, { useEffect, useState } from 'react';
import { helpCenterFaqs, helpCenterTitle } from './HelpCenterContent';
import './HelpCenterStyle.css';

const HelpCenterPage: React.FC = () => {
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = helpCenterTitle;
  }, []);

  const toggleQuestion = (index: number) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <div className="help-center-page">
      <div className="help-center-inner">
        <header className="help-center-hero">
          <p className="help-center-kicker">帮助中心</p>
          <h1 className="help-center-title">{helpCenterTitle}</h1>
          <p className="help-center-subtitle">资金托管、退款、发票与服务进展</p>
        </header>
        <div className="help-center-list">
          {helpCenterFaqs.map((faq, index) => {
            const opened = openIndex === index;
            return (
              <section
                key={faq.question}
                className={opened ? 'help-center-card is-open' : 'help-center-card'}
              >
                <button
                  type="button"
                  className="help-center-question"
                  aria-expanded={opened}
                  onClick={() => toggleQuestion(index)}
                >
                  <span className="help-center-index">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="help-center-question-text">{faq.question}</span>
                  <span className="help-center-chevron" aria-hidden="true" />
                </button>
                {opened && (
                  <div className="help-center-answers">
                    {faq.answers.map((answer) => (
                      <p key={answer} className="help-center-answer">
                        {answer}
                      </p>
                    ))}
                  </div>
                )}
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HelpCenterPage;
